import React, {useState, useEffect} from "react";
import ProjectAPIs from "../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate, useParams } from "react-router-dom";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { Form } from "react-bootstrap";
import DropDown from "../../../../../../DropDown/DropDown";
import CompanyAPIs from "../../../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import ApiResponseHandler from "../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../../Contexts/ToastContext";

export default function ViewProjectArchitect(){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [architectData, setArchitectData] = useState({});
    const [employees, setEmployees] = useState([]);

    const [architectCompanyID, setArchitectCompanyID] = useState();
    const [architectID, setArchitectID] = useState();

    const getArchitectData = (projectID) => {
        ProjectAPIs.GetProjectArchitect(projectID)
        .then((response) => {
            if(response.status === 200){
                setArchitectData(response.data);
                setArchitectCompanyID(response.data.company?.id ?? '');
                setArchitectID(response.data.architect_id ?? '');
                // setPhone(response.data.phone);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const getEmployees = () => {
        CompanyAPIs.GetCompanyEmployees(architectData.company.id)
        .then((response) => {
            setEmployees(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const editProjectArchitect = (e) => {

        e.preventDefault();
        e.stopPropagation();
        setSending(true);
        const putJSON = {
            architect_company_id: architectCompanyID === '' ? null : parseInt(architectCompanyID),
            architect_id: architectID === '' ? null : parseInt(architectID)
            // phone: phone
        }
        ProjectAPIs.PutProjectArchitect(params.ProjectID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getArchitectData(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Architect updated successfully!", variant: "success", autoHide: true });

            }
        })
        .catch((err) => {
            console.log(err)
            ApiResponseHandler(err.response, navigate)
        })
    }

    const handleCancel = () => {
        setArchitectID(architectData.architect_id ?? '')
        setArchitectCompanyID(architectData.company?.id ?? '');
        setEditing(false);
    }

    const handleChangeCompany = (e) => {
        setArchitectCompanyID(e.target.value);
        setArchitectID('');
    }

    useEffect(() => {
        getArchitectData(params.ProjectID);
    }, [params.ProjectID])

    useEffect(() => {
        if(architectData.company){
            getEmployees();
        }
    }, [architectData, params.projectID])
    
    if(loading){
        return(
            <div>Loading...</div>
        )
    }
    return(
        <div className="project-section">
            <Form onSubmit={editProjectArchitect}>
                <div className="project-seciton-header">
                    <h5 >Architecture</h5>
                    <div className="project-header-actions m-1">
                        <button
                            disabled={sending || !editing}
                            type="submit"
                            className="save-btn"
                            style={editing ? {display: 'block'} : {display: 'none'}}
                        >
                            {sending ? 'Saving...' : 'Save'}
                        </button>

                        {editing ? (
                            <button
                                disabled={sending}
                                type="button"
                                className="cancel-btn"
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                        ) : (
                            <button
                                disabled={sending}
                                type="button"
                                className="edit-btn"
                                onClick={() => setEditing(true)}
                            >
                                <MdEdit /> Edit
                            </button>
                        )}
                    </div>
                </div>

            <div className="project-section-body">
                {editing?
                    <div className="project-section-body-item">
                        <DropDown.AllCompanies disabled={sending} className='editable-field' value={architectCompanyID} onChange={handleChangeCompany} />
                    </div>
                    :
                    <div className="project-section-body-item">
                        <h5>{architectData.company?.name ?? ''}</h5>
                    </div>
                }

                {editing ? 
                    <div className="project-section-body-item">
                        <span className="label">Engineer</span>
                        <DropDown.CompanyEmployees 
                            companyID={architectCompanyID} 
                            value={architectID}
                            onChange={(e) => setArchitectID(e.target.value)}
                            disabled={!editing || sending}
                            size='sm'
                            className='editable-field'
                        />
                    </div>
                :
                <div className="project-section-body-item">
                    <span className="label">Architect</span>
                    {employees.find((e) => e.id === architectData.architect_id)?.first_name ?? ''} {employees.find((e) => e.id === architectData.architect_id)?.last_name ?? ''} 
                </div>
                }
                <div className="project-section-body-item">
                    <span className="label">Phone</span>
                    {architectData.phone}
                </div>
                <div className="project-section-body-item">
                    <span className="label">Email</span>
                    {architectData.email}
                </div>
            </div>

            </Form>
        </div>

    )
    
}